<template>
    <div class="general-select">
        <label v-if="label" class="general-select-label mb-1" :class="lightLabel ? 'light' : ''">
            {{ label }}
        </label>

        <div class="general-select-value d-flex align-items-center"
            ref="select"
            :class="[error ? 'error' : '']" 
            @click="toggleList"
        >
            <div class="general-select-indicator" 
                v-if="selected && selected.indicatorColor" 
                :style="selected.indicatorColor ? `background: ${selected.indicatorColor};` : ''"
            ></div>

            <span class="general-select-text"
                :class="!selected ? 'placeholder' : ''"
            >
                {{ selected ? selected.label : placeholder }}
            </span>
            <span class="caret">&#9660;</span>
        </div>

        <div class="general-select-options" >
            <div
                v-for="(option, i) in options" :key="i"
                class="general-select-option d-flex align-items-center"
                :class="selected == option ? 'selected' : ''"
                @click="selectOption(option)"
            >
                <div class="general-select-indicator" 
                    v-if="option.indicatorColor" 
                    :style="option.indicatorColor ? `background: ${option.indicatorColor};` : ''"
                ></div>
                <span class="general-select-text">{{ option.label }}</span>
                <span v-if="selected == option">
                    &#10003;
                </span>
            </div>
        </div>

        <small class="error-message" v-if="error">{{ error }}</small>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        lightLabel: {
            type: Boolean,
            default: false,
        },
        value: {},
        options: {
            type: Array,
            default: () => [
                { label: 'Label 1', value: 1 },
                { label: 'Label 2', value: 2 },
                { label: 'Label 3', value: 3 },
                { label: 'Label 4', value: 4 },
                { label: 'Label 5', value: 5 },
            ],
        },
        placeholder: {
            type: String,
            default: 'Placeholder',
        },
        error: {
            type: String,
        },
    },
    watch: {
        value: function (value) {
            this.selected = this.options.find(el => el.value == this.value);
        }
    },
    data: function () {
        return {
            selected: this.options.find(el => el.value == this.value),
        }
    },
    methods: {
        toggleList() {
            let content = this.$refs.select.nextElementSibling;
            this.$refs.select.classList.toggle('open');
            content.classList.toggle('open');
            
            if (content.style.maxHeight)
                content.style.maxHeight = null;
            else
                content.style.maxHeight = content.scrollHeight + "px";
        },

        selectOption(option) {
            this.selected = option;
            this.toggleList();

            this.$emit('input', option.value);
        }
    }
}
</script>

<style lang="scss">
.general-select {
    position: relative;
    user-select: none;

    &-indicator {
        height: 1rem;
        width: 1rem;
        margin-right: 1rem;
        border: black solid 1px;
    }
    
    &-label {
        color: black;
        font-size: 1rem;
        font-weight: 600;
        display: block;

        &.light {
            font-weight: 500;
        }
    }

    &-text {
        display: inline-block;
        margin-right: auto;
        font-size: 14px;
        font-weight: 400;

        &.placeholder {
            color: rgba(darken(#B5B5B5, 20%), 0.5);
        }
    }

    &-value {
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 5px;
        padding: 0.5rem 0.5rem;
        transition: all 0.1s ease;
        background: white;
        cursor: pointer;
        
        .caret {
            margin-left: 0.5rem;
            transition: all 0.2s ease;
            font-size: 14px;
        }

        &.open {
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;

            .caret {
                transform:rotateX(180deg);
            }
        }
        
        &.error {
            border-color: #B43927;
        }
    }

    &-options {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 10;
        background: #FCFCFC;
        max-height: 0;
        overflow-y: scroll;
        transition: all 0.1s ease;

        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;

        &.open {
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-top: none;
        }
    }

    &-option {
        cursor: pointer;
        transition: all 0.1s ease;
        padding: 0.5rem 0.5rem;

        &:hover {
            background: rgba(#000, 0.1);
        }

        &.selected {
            color: white;
            background: #007bff;
        }
        
    }

    .error-message {
        padding-top: 0.25rem;
        color: #B43927;
    }
}
</style>


// WEBPACK FOOTER //
// GeneralSelect.vue?5afbf2e7